/**
 * Language-aware URL slug generator.
 * - Lowercases + ASCII-folds diacritics (é→e, ñ→n, ü→u, ø→o, å→a, æ→ae, etc.)
 * - Replaces any non-alphanumeric with a single hyphen
 * - Trims leading/trailing hyphens, collapses repeats
 * - Caps length at 80 chars (breaking on the last hyphen when possible)
 *
 * Mirrors supabase/functions/_shared/slugify.ts — keep in sync.
 */
const CHAR_MAP: Record<string, string> = {
  ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss',
  å: 'a', æ: 'ae', ø: 'o',
  ñ: 'n', ç: 'c',
};

export function slugify(input: string): string {
  if (!input) return '';

  const lower = input.toLowerCase();

  // Apply special language mappings first (before diacritic stripping).
  let mapped = '';
  for (const ch of lower) {
    mapped += CHAR_MAP[ch] ?? ch;
  }

  // Strip remaining diacritics (é → e).
  const ascii = mapped.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

  // Replace non-word chars with hyphens, collapse, trim.
  let out = ascii
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  if (out.length > 80) {
    const cut = out.slice(0, 80);
    const lastDash = cut.lastIndexOf('-');
    out = lastDash > 40 ? cut.slice(0, lastDash) : cut;
  }

  return out;
}
